import confirmTip from '../confirmTip/confirmTip.vue'
import modalUpdateResult from '../modalUpdateResult/modalUpdateResult.vue'
import leadLoading from '../leadLoading/leadLoading.vue'
import progressTask from '../progressTask/progressTask.vue'
import modalAlike from '../modalAlike/modalAlike.vue'

const pgMessage = {}
pgMessage.install = function (vue) {
  // confirmTip
  const exampeTip = vue.extend(confirmTip)
  let exampeDom
  const initInstance = () => {
    // 实例化vue实例
    // eslint-disable-next-line new-cap
    exampeDom = new exampeTip()
    let el = exampeDom.$mount().$el
    document.body.appendChild(el)
  }
  // confirmTip
  const exampeTipNotOnly = vue.extend(confirmTip)
  let exampeDomNotOnly
  const initInstanceNotOnly = () => {
    // 实例化vue实例
    // eslint-disable-next-line new-cap
    exampeDomNotOnly = new exampeTipNotOnly()
    let el = exampeDomNotOnly.$mount().$el
    document.body.appendChild(el)
  }

  // modalUpdateResult
  const resultTip = vue.extend(modalUpdateResult)
  let resultDom
  const resultInitInstance = () => {
    // 实例化vue实例
    // eslint-disable-next-line new-cap
    resultDom = new resultTip()
    let el = resultDom.$mount().$el
    document.body.appendChild(el)
  }

  // leadLoading
  const leadLoadingTip = vue.extend(leadLoading)
  let leadLoadingDom
  const leadLoadingInitInstance = () => {
    // 实例化vue实例
    // eslint-disable-next-line new-cap
    leadLoadingDom = new leadLoadingTip()
    let el = leadLoadingDom.$mount().$el
    document.body.appendChild(el)
  }

  // progressTask
  const progressTaskTip = vue.extend(progressTask)
  let progressTaskDom
  const progressTaskInitInstance = () => {
    // 实例化vue实例
    // eslint-disable-next-line new-cap
    progressTaskDom = new progressTaskTip()
    let el = progressTaskDom.$mount().$el
    document.body.appendChild(el)
  }

  // modalAlike
  const alikeTip = vue.extend(modalAlike)
  let alikeDom
  const alikeInitInstance = () => {
    // 实例化vue实例
    // eslint-disable-next-line new-cap
    alikeDom = new alikeTip()
    let el = alikeDom.$mount().$el
    document.body.appendChild(el)
  }

  vue.prototype.$pgMessage = {
    confirm(options) {
      if (exampeDom) {
        document.body.removeChild(exampeDom.$el)
      }
      initInstance()

      let deadFn = function () {
        if (exampeDom) {
          exampeDom.$destroy()
          document.body.removeChild(exampeDom.$el)
          for (let key in options) {
            delete exampeDom[key]
          }
          exampeDom = null
          console.info('exampeDom.$destroy confirm')
        }
      }

      if (typeof options === 'string') {
        exampeDom.content = options
        exampeDom.routerInfo = options
        exampeDom.cancel = deadFn
        exampeDom.onOk = deadFn
        exampeDom.onOkRight = deadFn
      } else if (typeof options === 'object') {
        if ('mask' in options) exampeDom.mask = options.mask
        if ('content' in options) exampeDom.content = options.content
        if ('title' in options) exampeDom.title = options.title
        if ('sureBtnText' in options) exampeDom.sureBtnText = options.sureBtnText
        if ('sureBtnTextRight' in options) exampeDom.sureBtnTextRight = options.sureBtnTextRight
        if ('cancelBtnText' in options) exampeDom.cancelBtnText = options.cancelBtnText
        if ('cancelBtnType' in options) exampeDom.cancelBtnType = options.cancelBtnType
        if ('cancelBtnPlain' in options) exampeDom.cancelBtnPlain = options.cancelBtnPlain
        if ('showSureBtnRight' in options) {
          exampeDom.showSureBtnRight = options.showSureBtnRight
          exampeDom.showCancelBtn = options.showSureBtnRight ? false : true
        }
        if ('showCancelBtn' in options) exampeDom.showCancelBtn = options.showCancelBtn
        if ('forceSureBtn' in options) exampeDom.forceSureBtn = options.forceSureBtn
        if ('countdown' in options) exampeDom.countdown = options.countdown
        /**
         * 需求3067 【灵科紧急】库存备货分析表支持生成采购计划单（可选验收条件）
         * 【可选】请UX部门关注：建议生单操作成功后，提示信息中直接添加新单据的超链接，
         * 以便用户想立即查看该单据时，马上可以打开，避免再到菜单中寻找，非常的麻烦。
         * routerInfo：{name：路由名称，function，id：单据id}
         *  */
        if ('routerInfo' in options) exampeDom.routerInfo = options.routerInfo
        if ('parentVue' in options) exampeDom.parentVue = options.parentVue
        if ('maskClosable' in options) exampeDom.maskClosable = options.maskClosable
        if ('closable' in options) exampeDom.closable = options.closable
        if ('sureBtnTip' in options) exampeDom.sureBtnTip = options.sureBtnTip
        if ('cancel' in options) {
          exampeDom.cancel = function () {
            options.cancel()
            deadFn()
          }
        } else {
          exampeDom.cancel = deadFn
        }
        if ('onOk' in options) {
          exampeDom.onOk = function () {
            options.onOk()
            deadFn()
          }
        } else {
          exampeDom.onOk = deadFn
        }
        if ('onOkRight' in options) {
          exampeDom.onOkRight = function () {
            options.onOkRight()
            deadFn()
          }
        } else {
          exampeDom.onOkRight = deadFn
        }
      }
      exampeDom.show()
      return exampeDom
    },
    confirmNotOnly(options) {
      initInstanceNotOnly()
      let deadFn = function () {
        if (exampeDomNotOnly) {
          exampeDomNotOnly.$destroy()
          document.body.removeChild(exampeDomNotOnly.$el)
          for (let key in options) {
            delete exampeDomNotOnly[key]
          }
          exampeDomNotOnly = null
          console.info('exampeDomNotOnly.$destroy confirmNotOnly')
        }
      }
      if (typeof options === 'string') {
        exampeDomNotOnly.content = options
        exampeDomNotOnly.cancel = deadFn
        exampeDomNotOnly.onOk = deadFn
        exampeDomNotOnly.onOkRight = deadFn
      } else if (typeof options === 'object') {
        if ('mask' in options) exampeDomNotOnly.mask = options.mask
        if ('content' in options) exampeDomNotOnly.content = options.content
        if ('title' in options) exampeDomNotOnly.title = options.title
        if ('sureBtnText' in options) exampeDomNotOnly.sureBtnText = options.sureBtnText
        if ('sureBtnTextRight' in options)
          exampeDomNotOnly.sureBtnTextRight = options.sureBtnTextRight
        if ('cancelBtnText' in options) exampeDomNotOnly.cancelBtnText = options.cancelBtnText
        if ('showCancelBtn' in options) exampeDomNotOnly.showCancelBtn = options.showCancelBtn
        if ('showSureBtnRight' in options)
          exampeDomNotOnly.showSureBtnRight = options.showSureBtnRight
        if ('cancel' in options) {
          exampeDomNotOnly.cancel = function () {
            options.cancel()
            deadFn()
          }
        } else {
          exampeDomNotOnly.cancel = deadFn
        }
        if ('onOk' in options) {
          exampeDomNotOnly.onOk = function () {
            options.onOk()
            deadFn()
          }
        } else {
          exampeDomNotOnly.onOk = deadFn
        }
        if ('onOkRight' in options) {
          exampeDomNotOnly.onOkRight = function () {
            options.onOkRight()
            deadFn()
          }
        } else {
          exampeDomNotOnly.onOkRight = deadFn
        }
      }
      exampeDomNotOnly.show()
      return exampeDomNotOnly
    },
    modalUpdateResult(options) {
      if (resultDom) {
        document.body.removeChild(resultDom.$el)
      }
      resultInitInstance()

      let deadFn = function () {
        if (resultDom) {
          resultDom.$destroy()
          document.body.removeChild(resultDom.$el)
          for (let key in options) {
            delete resultDom[key]
          }
          resultDom = null
          console.info('resultDom.$destroy modalUpdateResult')
        }
      }

      if (typeof options === 'string') {
        resultDom.title = options
        resultDom.deadFn = deadFn
      } else if (typeof options === 'object') {
        // modalUpdateResult组件新增了这个参数，必须传空，不然有问题，fpr
        resultDom.textTemplate = ''
        if ('textTemplate' in options) resultDom.textTemplate = options.textTemplate
        if ('title' in options) resultDom.title = options.title
        if ('textUpdateResult' in options) resultDom.textUpdateResult = options.textUpdateResult
        if ('errorText' in options) resultDom.errorText = options.errorText
        if ('errorTextAfter' in options) resultDom.errorTextAfter = options.errorTextAfter
        if ('resultData' in options) resultDom.resultData = options.resultData
        if ('uploadFaildStatus' in options) resultDom.uploadFaildStatus = options.uploadFaildStatus
        if ('leftText' in options) resultDom.leftText = options.leftText
        if ('hideOfSuccessMessage' in options)
          resultDom.hideOfSuccessMessage = options.hideOfSuccessMessage
        if ('hideOfErrorMessage' in options)
          resultDom.hideOfErrorMessage = options.hideOfErrorMessage
        if ('sureClose' in options) {
          resultDom.sureClose = function (close) {
            options.sureClose(close)
            deadFn()
          }
        } else {
          resultDom.deadFn = deadFn
        }
        if ('leftSure' in options) {
          resultDom.leftSure = function () {
            options.leftSure()
            deadFn()
          }
        }
        // Object.assign(resultDom, options);
      }
      resultDom.show()
      return resultDom
    },
    leadLoading(options) {
      if (leadLoadingDom) {
        document.body.removeChild(leadLoadingDom.$el)
      }
      leadLoadingInitInstance()

      let deadFn = function () {
        if (leadLoadingDom) {
          leadLoadingDom.$destroy()
          document.body.removeChild(leadLoadingDom.$el)
          for (let key in options) {
            delete leadLoadingDom[key]
          }
          leadLoadingDom = null
          console.info('leadLoadingDom.$destroy leadLoading')
        }
      }

      if (typeof options === 'string') {
        leadLoadingDom.loadingText = options
        leadLoadingDom.deadFn = deadFn
      } else if (typeof options === 'object') {
        if ('show' in options) leadLoadingDom.value = options.show
        if ('closable' in options) leadLoadingDom.closable = options.closable
        if ('maskClosable' in options) leadLoadingDom.maskClosable = options.maskClosable
        if ('draggable' in options) leadLoadingDom.draggable = options.draggable
        if ('mask' in options) leadLoadingDom.mask = options.mask
        if ('loadingText' in options) leadLoadingDom.loadingText = options.loadingText
        if ('terminationText' in options) leadLoadingDom.terminationText = options.terminationText
        if ('terminationShow' in options) leadLoadingDom.terminationShow = options.terminationShow
        if ('isBody' in options) leadLoadingDom.isBody = options.isBody
        if ('ok' in options) {
          leadLoadingDom.ok = function () {
            options.ok()
            deadFn()
          }
        } else {
          leadLoadingDom.ok = deadFn
        }
        if ('cancel' in options) {
          leadLoadingDom.cancel = function () {
            options.cancel()
            deadFn()
          }
        } else {
          leadLoadingDom.cancel = deadFn
        }
        // Object.assign(leadLoadingDom, options);
      }
      return leadLoadingDom
    },
    progressTask(options) {
      if (progressTaskDom) {
        document.body.removeChild(progressTaskDom.$el)
      }
      progressTaskInitInstance()

      let deadFn = function () {
        if (progressTaskDom) {
          progressTaskDom.$destroy()
          document.body.removeChild(progressTaskDom.$el)
          for (let key in options) {
            delete progressTaskDom[key]
          }
          progressTaskDom = null
          console.info('progressTaskDom.$destroy progressTask')
        }
      }

      if (typeof options === 'object') {
        if ('maskClosable' in options) progressTaskDom.maskClosable = options.maskClosable
        if ('loadingText' in options) progressTaskDom.loadingText = options.loadingText
        if ('ifSureClose' in options) progressTaskDom.ifSureClose = options.ifSureClose
        if ('urlProgress' in options) progressTaskDom.urlProgress = options.urlProgress
        if ('data' in options) progressTaskDom.data = options.data
        if ('title' in options) progressTaskDom.title = options.title
        if ('resultTemplate' in options) progressTaskDom.resultTemplate = options.resultTemplate
        if ('textTemplate' in options) progressTaskDom.textTemplate = options.textTemplate
        if ('leftText' in options) progressTaskDom.leftText = options.leftText
        if ('routerObj' in options) progressTaskDom.routerObj = options.routerObj

        if ('onComplete' in options) {
          progressTaskDom.onComplete = function (res) {
            options.onComplete(res)
            deadFn()
          }
        } else {
          progressTaskDom.deadFn = deadFn
        }
        if ('sureClose' in options) {
          progressTaskDom.sureClose = function (flag, res) {
            options.sureClose(flag, res)
            deadFn()
          }
        } else {
          progressTaskDom.deadFn = deadFn
        }
        // Object.assign(progressTaskDom, options);
      }
      return progressTaskDom
    },
    modalAlike(options) {
      if (alikeDom) {
        document.body.removeChild(alikeDom.$el)
      }
      alikeInitInstance()

      let deadFn = function () {
        if (alikeDom) {
          alikeDom.$destroy()
          document.body.removeChild(alikeDom.$el)
          for (let key in options) {
            delete alikeDom[key]
          }
          alikeDom = null
          console.info('alikeDom.$destroy modalAlike')
        }
      }

      if (typeof options === 'string') {
        alikeDom.title = options
        alikeDom.deadFn = deadFn
      } else if (typeof options === 'object') {
        if ('title' in options) alikeDom.title = options.title
        if ('textOfCheckBox' in options) alikeDom.textOfCheckBox = options.textOfCheckBox
        if ('content' in options) alikeDom.content = options.content
        if ('onOk' in options) {
          alikeDom.onOk = function (val) {
            options.onOk(val)
            deadFn()
          }
        } else {
          alikeDom.deadFn = deadFn
        }
      }
      alikeDom.show()
      return alikeDom
    },
  }
}

export default pgMessage
